module.exports = __webpack_public_path__ + "src/assets/img/contentcoorditanion.c4c096cd.jpg";